module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0101.jpg?v=3378dd78";